<template>
  <div class="app-layout">
    <!-- Main Content -->
    <div class="main">
      <!-- Header -->

      <!-- Page Content -->
      <div :class="active === 'trained-document' ? 'main-content-trained' : 'main-content'">
        <slot />
      </div>
      <!-- Footer -->
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
// const props = defineProps({
//   active: String, // e.g. 'dashboard', 'job-history', 'new-job', 'report'
//   showMarquee: Boolean,
// })
const router = useRouter()
const route = useRoute()
const active = route.name || route.path

function goTo(path) {
  router.push(path)
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@700&display=swap');
/* ... (same styles as before) ... */
.app-layout {
  display: flex;
  min-height: 100vh;
  font-family: 'Archivo', Arial, sans-serif;
  background: #eaf6fb;
}
.sidebar {
  width: 104px;
  background: #19425b;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0 0 0;
  box-shadow: 2px 0 8px 0 #0001;
  height: 97.5vh;
}
.sidebar-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
}
.sidebar-logo img {
  width: 84px;
  height: 78px;
}
.logo-title {
  color: #fff;
  font-size: 1.02rem;
  font-weight: 700;
  margin-top: 2px;
  letter-spacing: 1px;
}
.sidebar-nav {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 12px;
}
.sidebar-profile {
  margin-top: auto;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.profile-avatar {
  background: #c1e2ff;
  color: #19425b;
  font-size: 1.11rem;
  font-weight: 700;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  box-shadow: 0 2px 8px #0001;
}
.profile-label {
  color: #fff;
  font-size: 0.93rem;
  font-weight: 500;
  text-align: center;
}
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  background: #eaf6fb;
}
.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #eaf6fb;
  padding: 5px 36px 5px 36px;
  min-height: 60px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 9px;
}
.main-title {
  color: #164863;
  font-size: 26px;
  font-weight: 700;
  font-family: 'Orbitron', Arial, sans-serif;
  letter-spacing: 0.7px;
  white-space: nowrap;
  padding-right: 10px;
}
.header-right {
  margin-left: auto;
}
.header-desc {
  color: #164863;
  font-size: 20px;
  font-weight: 500;
  font-style: italic;
  font-family: 'Archivo', Arial, sans-serif;
  opacity: 0.85;
  white-space: nowrap;
  padding-left: 10px;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* padding: 0 26px 0 26px; */
  min-width: 0;
  background: var(--secondary-color);
}

.main-content-trained {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 26px 0 26px;
  min-width: 0;
}
.main-footer {
  background: transparent;
  color: #164863;
  font-size: 12px;
  font-family: 'Archivo', Arial, sans-serif;
  padding: 7px 30px 12px 0;
  text-align: right;
  letter-spacing: 0.03em;
  border-bottom-right-radius: 18px;
  /* stick to bottom */
  margin-top: auto;
}
.marquee-container {
  overflow: hidden;
  width: 100%;
  background: transparent;
  margin: 10px 0;
}

.marquee-msg {
  display: inline-block;
  white-space: nowrap;
  color: red;
  font-weight: bold;
  font-size: 1rem;
  animation: marquee 10s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
